import { Dispatch, SetStateAction } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { createPortal } from 'react-dom';

export default function NotCoveredPopUp({
  onClose,
}: {
  onClose: Dispatch<SetStateAction<boolean>>;
}) {
  return createPortal(
    <div
      onClick={() => onClose(false)}
      className="fixed inset-0 z-[99999] flex h-[100dvh] w-[100dvw] items-center justify-center bg-[rgba(0,0,0,0.5)] p-4"
    >
      <div className="max-h-[690px] w-full max-w-[360px] rounded-xl bg-white">
        <div className="flex justify-end p-4 pb-0 ">
          <button onClick={() => onClose(false)}>
            <CloseRoundedIcon />
          </button>
        </div>
        <div className="p-6 pt-0">
          <h6 className="pb-4 text-lg font-bold">Not available in your country yet</h6>
          <p className="text-base">
            We don't currently offer coverage in your region, so we're unable to provide a quote. 
            We've noted your interest and will be in touch as soon as a suitable product becomes available for you.
          </p>
        </div>
      </div>
    </div>,
    document.body
  ) as JSX.Element;
}
